import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../../core'
import * as goal from '../../goal'

export const RESOURCE = {
  payload: {
    modelId: goal.MODEL_ID,
    values: {
      // TODO: get multi-range to work
      // 'active_periods': new AtnMultirange<Date>(),
      [PartialId.Standard.create('active_periods')]: '{[1-1-2023,12-31-2026]}',
      [PartialId.Standard.create('code')]: '1.1.5',
      [PartialId.Standard.create('descr')]:
        'Strategically leverage and invest resources to continue to build a portfolio of choice through online and hybrid programming. ',
      [PartialId.Standard.create('id')]: 'gmu_1_1_5',
      [PartialId.Standard.create('name')]: 'Online and hybrid programming',
    },
  },
  type: core.quiver.Resource.Type.DmsRecord,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsRecord>
